import { createContext, useState } from "react";

export const SideBarContext = createContext({
    selectedOption: null,
    setSelectedOption: () => {},
});

export const Options = {
    DashBoard: "Dashboard",
    Adventures: "Adventures",
    Destinations: "Destinations",
    AddImage: "AddImage",
    Programmes: "Programmes",
}

export const SideBarProvider = ({children}) => {
    const [selectedOption, setSelectedOption] = useState(Options.Destinations);

    const value = {selectedOption, setSelectedOption}

    return <SideBarContext.Provider value={value}>{ children }</SideBarContext.Provider>
}